import { ProcessDto } from '../../../shared/remote-services/dtos/process.dto'
import { EntitiesActionFactory } from '../../../shared/utils/redux/entities/entities.actions'

export class ProcessesActions {
  public static loadProcesses = new EntitiesActionFactory<ProcessDto, void>(
    '[CORE] LOAD PROCESSES',
  )
}
